import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface AdsServiceObject {
  id: number;
  titleEn: string;
  titleAr: string;
  slug: string;
  isActive: boolean;
  level: number;
  duration: number;
}
export interface AddServiceListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  AdsService: Array<AdsServiceObject>;
  errors: unknown;
}

@Module
export default class AdServiceModule
  extends VuexModule
  implements AddServiceListInfo
{
  AdsService = [] as Array<AdsServiceObject>;
  AdsServices = [] as Array<AdsServiceObject>;

  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get Ads list
   * @returns Array<AdsObject>
   */
  get adsServicesList(): Array<AdsServiceObject> {
    return this.AdsService;
  }

  /**
   * Get Ads list
   * @returns Array<AdsObject>
   */
  get adsServicesDdl(): Array<AdsServiceObject> {
    return this.AdsServices;
  }

  /**
   * Get total items
   * @returns number
   */
  get adsServicesListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_ADS_SERVICES_DDL](data) {
    this.AdsServices = data.data;
  }

  @Mutation
  [Mutations.SET_ADS_SERVICES](data) {
    this.AdsService = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_ADS_SERVICES_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_ADS_SERVICE_LIST]() {
    this.AdsService = [] as Array<AdsServiceObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_ADS_SERVICE_STORE]() {
    this.context.commit(Mutations.RESET_ADS_SERVICE_LIST);
  }

  @Action
  [Actions.UPDATE_ADS_SERVICES_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_ADS_SERVICES_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_AD_SERVICE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/ads-services', id);
  }

  @Action
  [Actions.GET_ADS_SERVICES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/ads-services', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        data.data = data.data.map((r) => {
          r.createdAt = new Date(r.createdAt)
            .toLocaleString('en-GB')
            .split(',')[0];
          return r;
        });
        this.context.commit(Mutations.SET_ADS_SERVICES, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.CREATE_AD_SERVICE](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/ads-services', data)
      .then(() => {
        this.context.commit(Mutations.RESET_ADS_SERVICE_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }
  @Action
  [Actions.UPDATE_AD_SERVICE]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/ads-services', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_ADS_SERVICE_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_AD_SERVICE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/ads-services', id)
      .then(() => {
        this.context.commit(Mutations.RESET_ADS_SERVICE_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }
  @Action
  [Actions.GET_SERVICE_LIST](options: { limit?: number } = { limit: 10 }) {
    ApiService.setAuthorizationHeader();
    const params = { page: this.currentPage, limit: options.limit };
    return ApiService.query('/ads-services/all', { params })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ADS_SERVICES_DDL, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
}
